/**
 * Event lifecycle and join-access helpers shared by create/join UI, clients,
 * and tests. Firestore remains the source of truth; these functions only
 * interpret the fields the client already reads.
 */

export const EVENT_STATUS = {
  active: 'active',
  ended: 'ended',
};

export const JOIN_MODE = {
  open: 'open',
  approval: 'approval',
};

export const JOIN_REQUEST_STATUS = {
  pending: 'pending',
  approved: 'approved',
  denied: 'denied',
};

/** Missing status is treated as live so pre-lifecycle events keep working. */
export function isEventLive(eventData) {
  if (!eventData) return false;
  return eventData.status == null || eventData.status === EVENT_STATUS.active;
}

export function isEventEnded(eventData) {
  if (!eventData) return false;
  return eventData.status === EVENT_STATUS.ended || eventData.endedAt != null;
}

export function normalizeJoinMode(value) {
  return value === JOIN_MODE.approval ? JOIN_MODE.approval : JOIN_MODE.open;
}

export function eventJoinMode(eventData) {
  return normalizeJoinMode(eventData?.settings?.joinMode);
}

export function isJoinApprovalRequired(eventData) {
  return isEventLive(eventData) && eventJoinMode(eventData) === JOIN_MODE.approval;
}
